import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';

import Panel from 'components/Helpers/Panel';
import s from './TechData.css';

class TechData extends React.Component {
  static propTypes = {
    techdata: PropTypes.shape().isRequired,
  };

  render() {
    const item = this.props.techdata;
    return (
      <Panel className={`${s.root} mt-2 mb-3`}>
        <p className="h4">
          <FormattedMessage
            id="endpage.techdata.heading"
            defaultMessage="Технічні характеристики"
            description=""
          />
        </p>
        <table className="table">
          <tbody>
            {item.properties.map(property => (
              <tr key={`td_${property.full_title}`}>
                <td>{property.full_title.replace(property.title, '')}</td>
                <td>
                  <b>{property.title}</b>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>
    );
  }
}

export default withStyles(s)(TechData);
